import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const CheckCircleFill = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M3.73 32.564q1.67 3.948 4.714 6.992 3.044 3.044 6.992 4.714Q19.526 46 24 46t8.564-1.73q3.948-1.67 6.992-4.714 3.044-3.044 4.714-6.992Q46 28.474 46 24t-1.73-8.564q-1.67-3.948-4.714-6.992Q36.512 5.4 32.564 3.73 28.474 2 24 2t-8.564 1.73Q11.488 5.4 8.444 8.444 5.4 11.488 3.73 15.436 2 19.526 2 24t1.73 8.564Zm31.684-13.15-12 12a2 2 0 0 1-2.828 0l-6-6a2 2 0 1 1 2.828-2.828L22 27.172l10.585-10.585a2.001 2.001 0 0 1 2.81-.02l.018.018h.001a2 2 0 0 1 0 2.83Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
